import AdminMessagesInbox from '../components/AdminMessagesInbox';

export default function AdminBorrowerMessages() {
  return <AdminMessagesInbox type="borrower" title="Borrower Messages" />;
}
